import React from 'react';
import TransferButton from '../transferbutton';

const TransferButtonRenderer = React.memo(({ data, userId, token }) => {
    return <TransferButton call={data} userId={userId} type="message" token={token} />;
});

export default TransferButtonRenderer;